import type { Canvas } from "fabric";
import {
  ASSET_LAYER_TYPE,
  IMAGE_LAYER_TYPE,
  LINE_LAYER_TYPE,
  SHAPE_LAYER_TYPE,
  TEXT_LAYER_TYPE,
} from "../constants.ts";
import {
  fabricObjectToLayer,
  isAssetLayer,
  isImageLayer,
  isLineLayer,
  isShapeLayer,
  isTextLayer,
} from "../typeguard.ts";
import type { Layer, LayerType } from "../types.ts";
import { normalizeLayerAngle } from "../utils/layer.ts";
import { useCanvasEventsListener } from "./useCanvasEventsListener.ts";

export const useLayerRotationEventListener = ({
  fabricCanvas,
  onLayerRotationEvent,
  layerType,
}: {
  fabricCanvas?: Canvas;
  layerType: LayerType;
  onLayerRotationEvent: (rotation: number) => void;
}) => {
  const updateRotation = (layer: Layer) => {
    onLayerRotationEvent(normalizeLayerAngle(layer.angle));
  };

  useCanvasEventsListener({
    eventTypes: ["object:rotating"],
    onEvent: () => {
      // FIXME: In case of multiple objects selected with different properties values, we should indicate to the user that the properties are not consistent.
      const activeObject = fabricCanvas?.getActiveObject();
      if (!activeObject) return;
      const layer = fabricObjectToLayer(activeObject);
      switch (layerType) {
        case LINE_LAYER_TYPE:
          if (layer && isLineLayer(layer)) updateRotation(layer);
          break;
        case TEXT_LAYER_TYPE:
          if (layer && isTextLayer(layer)) updateRotation(layer);
          break;
        case IMAGE_LAYER_TYPE:
          if (layer && isImageLayer(layer)) updateRotation(layer);
          break;
        case SHAPE_LAYER_TYPE:
          if (layer && isShapeLayer(layer)) updateRotation(layer);
          break;
        case ASSET_LAYER_TYPE:
          if (layer && isAssetLayer(layer)) updateRotation(layer);
          break;
      }
    },
    canvas: fabricCanvas,
  });
};
